module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/extroversion/09b4fdaf32274620927a23bedb8228ce.png";